// extracted by mini-css-extract-plugin
export default {"title":"AdminTitle_title__+UUuE"};